<template>
  <div class="main2-content">
    <div class="panel-content">
      <div class="model-head">
        <div class="model-title">
          <div class="model-line model-line-right">{{ title }} {{ titleEn }}</div>
          <div class="model-dot model-dot-right" v-for="item in 3" :key="item"></div>
        </div>
        <div class="btn-group btn-group-right">
          <div
            class="btn"
            :class="{ active: index == btnIndex }"
            v-for="(item, index) in btn"
            :key="index"
            @click="handleIndex(index)"
          >
            <div class="titel">{{ item.title }}</div>
            <div class="titleEn">{{ item.titleEn }}</div>
          </div>
        </div>
      </div>

      <!-- start 0 -->
      <div class="layout-flex" v-if="layoutShow(0)">
        <div class="layout-flex-2">
          <img :src="btn[this.btnIndex].img" style="width: 100%" />
        </div>
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec" v-html="btn[this.btnIndex].dec">
            </div>
            <div class="decEn" v-html="btn[this.btnIndex].decEn">
            </div>
            <div class="img">
              <img :src="btn[this.btnIndex].img2" style="width: 100%" />
            </div>
            <div style="text-align: right;margin-top: 20px;">
              <span class="detailBtn" style="vertical-align: bottom;margin-bottom: 10px;margin-left: 20px;line-height: normal;" @click="download">查看详情  ></span>
            </div>
          </div>
        </div>
      </div>

      <!-- start 1 -->
      <div class="layout-flex" v-if="layoutShow(1)">
        <div class="layout-flex-2">
          <img :src="btn[this.btnIndex].img" style="width: 100%" />
        </div>
        <div class="layout-flex-1">
          <div class="flex-head">
            <div class="dec">{{ btn[this.btnIndex].dec }}</div>
            <div class="decEn">{{ btn[this.btnIndex].decEn }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { csvw_url } from "../../components/config";
import config from "./config2";
export default {
  components: {},
  data() {
    return { ...config, btnIndex: 0 };
  },
  beforeMount() {},
  mounted() {},
  methods: {
    download() {
      window.open("https://www.csvw.com/csvw-website/news/company-news.html?newsid=3628&brand=undefined&title=%E4%B8%8A%E6%B1%BD%E5%A4%A7%E4%BC%97%E5%AE%98%E7%BD%91%EF%BC%9A%E2%80%9C%E7%AB%A5%E2%80%9D%E8%A1%8C%E7%AD%91%E6%A2%A6%20%E4%B8%8A%E6%B1%BD%E5%A4%A7%E4%BC%97%E2%80%9C%E7%B9%81%E6%98%9F%E8%AE%A1%E5%88%92%E2%80%9D2023%E5%B8%8C%E6%9C%9B%E5%B0%8F%E5%AD%A6%E5%A4%8F%E4%BB%A4%E8%90%A5%E5%BC%80%E8%90%A5", "_target");
    },
    layoutShow(val = 0) {
      if (val == this.btnIndex) {
        return true;
      } else {
        return false;
      }
    },
    handleIndex(index) {
      this.btnIndex = index;
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./common.less");
// 主题颜色
@colorValue: #ffffff;
// 描述字体颜色
@fontValue: #ffffff;
// 按钮激活字体颜色
@activeValue: #c4202e;

/deep/.el-collapse-item__header {
  color: @fontValue;
}

.collapse-scroll {
  color: @fontValue;
  // height: 150px;
  // overflow-y: auto;
}

.main2-content {
  color: @fontValue;
  background-image: url("../../assets/csr/imgs/BGtu2@2x.png");
  // background-color: @activeValue;
}

.model-head {
  .model-title {
    color: @colorValue;
    .model-line {
      border-bottom-color: @colorValue;
    }

    .model-dot {
      border-bottom-color: @colorValue;
    }
  }

  .btn-group {
    .btn {
      color: @colorValue;
      border-color: @colorValue;
    }
    .btn.active {
      color: @activeValue;
      background: @colorValue;
    }
  }
}

.flex-head {
  .subtitle {
    color: @colorValue;
  }
  .dec {
  }
  .img {
  }
}
</style>
